import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export function DiagnosticsBadge() {
  const [envStatus, setEnvStatus] = useState<'ok' | 'warning' | null>(null);

  useEffect(() => {
    const url = import.meta.env.VITE_SUPABASE_URL;
    const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

    if (!url || !key) {
      setEnvStatus('warning');
      console.warn('Environment check failed:', { hasUrl: !!url, hasKey: !!key });
    } else {
      setEnvStatus('ok');
    }
  }, []);

  // Só mostra em desenvolvimento
  if (import.meta.env.PROD || envStatus === 'ok') return null;

  return (
    <Badge variant="destructive" className="fixed bottom-4 right-4 z-50">
      <AlertTriangle className="w-4 h-4 mr-2" />
      Variáveis de ambiente ausentes
    </Badge>
  );
}
